'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import CardGalleryImages from '@app-ps/Components/Card/CardGalleryImages';
import MobileCardGallery from '@app-ps/Components/Card/MobileCardGallery';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const ScrollGallery = ({ sectionContent, lang, region }) => {
  const [screenSize, setScreenSize] = useState('desktop');
  const [screenSliderCount, setScreenSliderCount] = useState(6);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 425) {
        setScreenSize('mobile');
        setScreenSliderCount(1);
      } else if (window.innerWidth <= 1024) {
        setScreenSize('tablet');
        setScreenSliderCount(3);
      } else if (window.innerWidth <= 1400) {
        setScreenSize('1300');
        setScreenSliderCount(4);
      } else {
        setScreenSize('desktop');
        setScreenSliderCount(6);
      }
    };
    handleResize(); // Initial call to set screen size on mount
    // Event listener for window resize
    window.addEventListener('resize', handleResize);
    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {screenSize !== 'mobile' ? (
        <Box
          id="scroll-gallery"
          w={'100%'}
          my={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={5}
          backgroundColor={'black'}
          mx={'auto'}
          px={2}
        >
          {[1, 2, 3, 4, 5, 6].slice(0, screenSliderCount).map((data, index) => (
            <CardGalleryImages
              key={index}
              index={index}
              images={sectionContent[index]?.images}
            />
          ))}
        </Box>
      ) : (
        <Box w={'100%'} backgroundColor={'black'} mx={'auto'} py={2}>
          <MobileCardGallery
            images={
              sectionContent[0]?.mobileImages?.length > 0
                ? sectionContent[0]?.mobileImages
                : sectionContent[0]?.images
            }
          />
        </Box>
      )}
    </>
  );
};

export default ScrollGallery;
